// @flow
import React from 'react'
import FolderTree from './FolderTree'
import styles from './styles.css'
import type { TemplateNode } from 'lib/digital_file/model'

type Props = {
  template: Array<TemplateNode>,
  currentPath: ?string,
  target: ?string,
  onSelect: (path: string) => void,
}

const FolderTreePicker = ({ template, currentPath, target, onSelect }: Props) => {
  const rowClassName = (path: string, node: TemplateNode, hasChildren: boolean) => {
    const classes = [hasChildren ? styles.pickerBranch : styles.pickerLeaf]
    if (path === target) classes.push(styles.folderActive)
    if (path === currentPath) classes.push(styles.pickerCurrent)
    return classes.join(' ')
  }

  const renderRight = (path: string) =>
    path === currentPath ? <span className={styles.pickerCurrentTag}>current</span> : null

  const handleLeafClick = (path: string) => {
    if (path !== currentPath) onSelect(path)
  }

  return (
    <div className={styles.pickerTree}>
      <FolderTree
        template={template}
        expandPath={currentPath}
        rowClassName={rowClassName}
        renderRight={renderRight}
        onLeafClick={handleLeafClick}
      />
    </div>
  )
}

export default FolderTreePicker
